// 자료수집 포털 고객 화면 로고(브랜드) 선택 — 필요자료 등록 · 상세 정보 수정 · 엑셀 일괄등록 · 벤처인증 URL 복사 · 업무관리 자료수집 (2026-09-11, 사용자 지시)
//  roum = 계정 브랜딩(기존, 로움경영지도사무소) · atv = 주식회사 올댓벤처스 · law = 로움법무사사무소(2026-10-31) (서버 services/brandKit.js 와 동일 키)
import React from 'react';
import './brand.css';

export type BrandKey = 'roum' | 'atv' | 'law';
export const BRAND_OPTIONS: { key: BrandKey; label: string; short: string; hint: string }[] = [
  { key: 'roum', label: '로움경영지도사무소', short: '로움', hint: '기존과 같은 계정 로고' },
  { key: 'atv', label: '올댓벤처스', short: '올댓', hint: '주식회사 올댓벤처스 로고' },
  { key: 'law', label: '로움법무사사무소', short: '법무사', hint: '로움법무사사무소 로고' },
];
export const ATV_LOGO = '/brand/allthatventures-lockup.png';
export const ROUM_LOGO = '/brand/roum-wordmark.png';
export const LAW_LOGO = '/brand/roum-law-lockup.png';   // 로움법무사사무소 로고(사용자 제공 2026-10-31)
export const brandLogo = (v: unknown): string => ({ roum: ROUM_LOGO, atv: ATV_LOGO, law: LAW_LOGO }[normBrand(v)]);   // 로움경영지도사무소 워드마크 (사용자 제공 2026-09-11) — 선택 토글 표시용
export const normBrand = (v: unknown): BrandKey => (v === 'atv' || v === 'law' ? v : 'roum');
export const brandLabel = (v: unknown): string => (BRAND_OPTIONS.find(o => o.key === normBrand(v)) as { label: string }).label;
/** 안내 문자 머리말 「[임지도사]」 / 「[올댓벤처스]」 / 「[로움법무사사무소]」 — 로움 쪽 문자는 사무소 이름 대신 「임지도사」(2026-10-12 지도사) */
export const brandPrefix = (v: unknown): string => (normBrand(v) === 'roum' ? '[임지도사]' : '[' + brandLabel(v) + ']');

interface PickerProps {
  value: unknown;
  onChange: (v: BrandKey) => void;
  size?: 'sm' | 'md';
  label?: string | null;   // 앞 라벨 (기본 「고객 화면 로고」, null 이면 없음)
  disabled?: boolean;
  style?: React.CSSProperties;
  /** 고를 수 있는 로고만(벤처 조합 사무소처럼 로움 · 올댓만 있는 곳) — 없으면 모두 */
  only?: BrandKey[];
}

/** 3칸 토글 — 「로움경영지도사무소 | 올댓벤처스 | 로움법무사사무소」. 어느 모듈에서든 같은 모양 · 칸 너비 같게 */
export function BrandPicker({ value, onChange, size = 'md', label = '고객 화면 로고', disabled, style, only }: PickerProps) {
  const cur = normBrand(value);
  const opts = only ? BRAND_OPTIONS.filter(o => only.includes(o.key)) : BRAND_OPTIONS;
  const sm = size === 'sm';
  // 최소 폭: 큰 토글만 칸당 140px(화면 폭 안) · 작은 토글은 글자만큼. 예전 「100%」는 자기 틀을 기준으로 잡혀 라벨이 윗줄로 밀리고 옆 단추가 늘어났다(2026-11-02 벤처 수집 항목 머리)
  return (
    <div className={'brand-pick' + (sm ? ' sm' : '')} style={style} role="radiogroup" aria-label="고객 화면 로고">
      {label ? <span className="brand-pick-lbl">{label}</span> : null}
      <div className="brand-pick-seg" style={{ gridTemplateColumns: `repeat(${opts.length}, 1fr)`, minWidth: sm ? undefined : `min(${opts.length * 140}px, calc(100vw - 48px))` }}>
        {opts.map((o) => (
          <button key={o.key} type="button" role="radio" aria-checked={cur === o.key} disabled={disabled} title={o.hint}
            className={'brand-pick-opt' + (cur === o.key ? ' on' : '') + (o.key !== 'roum' ? ' ' + o.key : '')}
            onClick={() => { if (cur !== o.key) onChange(o.key); }}>
            <span>{sm ? o.short : o.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
